function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "cart_inline_svg__cart",
  stroke: "#FF0041",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "cart_inline_svg__Path-5",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.121 19h18l20.106 64.676h52.917L119 34.089H34.227"
}), /*#__PURE__*/React.createElement("circle", {
  id: "cart_inline_svg__Oval",
  strokeWidth: 8,
  cx: 43.5,
  cy: 109.5,
  r: 9.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "cart_inline_svg__Oval-Copy",
  strokeWidth: 8,
  cx: 98.5,
  cy: 109.5,
  r: 9.5
}), /*#__PURE__*/React.createElement("path", {
  id: "cart_inline_svg__Path-7",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M60.561 36.144L61 83.967"
}), /*#__PURE__*/React.createElement("path", {
  id: "cart_inline_svg__Path-8",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M43 56h65"
}), /*#__PURE__*/React.createElement("path", {
  id: "cart_inline_svg__Path-7-Copy",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M85 36.144v47.823"
}));

function SvgCartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCartinline;